import React, { useState, useEffect } from "react";
import "./ReportTableRow.css";
import {
  upsertSencoReport,
  getSencoReportByStudentId,
  getStudentClassDetail,
  updateStudent, // Import updateStudent
} from "../services/APIClient";
import SENWatchlistTable from "./SENWatchlistTable";
import Tooltip from "./Tooltip";
import { Modal, Button } from "react-bootstrap"; // Assuming you're using react-bootstrap

function SENWatchlistTableRow({
  student,
  dummyHeaderArray,
  getReadingScoreClass,
  handleShowLiteracyModal,
  handleShowAdditionalNeedsModal,
  handleShowSencoAdditionalNeedsModal,
  handleShowDetailsOfSetReceivedModal,
  handleShowPriorityConcernsModal,
  handleShowSencoSupportPlanModal,
  handleShowPlaceOnContinuumModal,
  handleShowClassroomSupportPlanModal,
  handleShowSencoEalModal,
  handleShowSetSetNameModal,
  handleShowSetModal,
  handleShowAttendanceAffectingScoresModal,
  teachers,
  teacherid,
  readingScores,
}) {
  const [literacyObservations, setLiteracyObservations] = useState("");
  const [additionalNeeds, setAdditionalNeeds] = useState([]);
  const [supportPlan, setSupportPlan] = useState([]);
  const [eal, setEal] = useState(false);
  const [set, setSet] = useState(false);
  const [studentSenState, setStudentSenState] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [isWatchlistChecked, setIsWatchlistChecked] = useState(true);

  const [attendanceAffectingScores, setAttendanceAffectingScores] =
    useState(false);
  const [setReceived, setSetReceived] = useState([]);
  const [priorityConcerns, setPriorityConcerns] = useState([]);
  const [sencoSupportPlan, setSencoSupportPlan] = useState([]);
  const [placeOnContinuum, setPlaceOnContinuum] = useState([]);
  const [classroomSupportPlan, setClassroomSupportPlan] = useState(false);
  const [sencoAdditionalNeeds, setSencoAdditionalNeeds] = useState([]);
  const [sencoEal, setSencoEal] = useState(false); // Updated state
  const [callClassName, setCallClassName] = useState("");
  const [setName, setSetName] = useState("");
  const [currentStudentId, setCurrentStudentId] = useState("");

  const [literacyButtonClicked, setLiteracyButtonClicked] = useState(false);
  const [additionalNeedsButtonClicked, setAdditionalNeedsButtonClicked] =
    useState(false);
  const [
    detailsOfSetReceivedButtonClicked,
    setDetailsOfSetReceivedButtonClicked,
  ] = useState(false);
  const [priorityConcernsButtonClicked, setPriorityConcernsButtonClicked] =
    useState(false);
  const [sencoSupportPlanButtonClicked, setSencoSupportPlanButtonClicked] =
    useState(false);
  const [classroomSupportPlanModalClicked, setClassroomSupportPlanClicked] =
    useState(false);
  const [placeOnContinuumButtonClicked, setPlaceOnContinuumButtonClicked] =
    useState(false);
  const [ealModalButtonClicked, setEalModalButtonClicked] = useState(false);
  const [setModalButtonClicked, setSetModalButtonClicked] = useState(false);
  const [attendanceModalButtonClicked, setAttendanceModalButtonClicked] =
    useState(false);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  const handleCheckboxClick = (student) => {
    setSelectedStudent(student);
    setShowConfirmationModal(true);
  };

  const handleConfirmRemove = () => {
    if (selectedStudent) {
      const currentSenState =
        studentSenState[selectedStudent.id] !== undefined
          ? studentSenState[selectedStudent.id]
          : selectedStudent.sen;

      setIsWatchlistChecked((prev) => !prev);
      handleSenToggle(selectedStudent.id, currentSenState);
    }
    setShowConfirmationModal(false);
    setSelectedStudent(null);
  };

  const handleCancelRemove = () => {
    setShowConfirmationModal(false);
    setSelectedStudent(null);
  };

  console.log(readingScores, "reading scores");

  const filteredTeachers = teachers
    .filter(
      (teacher) =>
        teacher.additionalRoles?.includes("SENCO") ||
        teacher.additionalRoles?.includes("SET")
    )
    .sort((a, b) => a.name.localeCompare(b.name)); // Sorting by teacher name alphabetically

  useEffect(() => {
    if (setName && currentStudentId) {
      const reportData = {
        studentid: currentStudentId,
        teacherid: teacherid,
        setname: setName,
      };

      console.log("Saving report data:", reportData);

      upsertSencoReport(reportData)
        .then((response) => {
          console.log("Upsert SENCO Report Success:", response);
        })
        .catch((error) => console.error("Error:", error));
    } else {
      if (!currentStudentId) {
        console.log("No student selected. Skipping save operation.");
      }
      if (!setName) {
        console.log("No set name provided. Skipping save operation.");
      }
    }
  }, [setName, currentStudentId, teacherid]);

  useEffect(() => {
    if (student.id) {
      getSencoReportByStudentId(student.id)
        .then((response) => {
          if (response) {
            // Ensure dateCreated is assigned to the student
            student.dateCreated = response.dateCreated || student.dateCreated;
            setCallClassName(response.classname || "");
            setSetName(response.setname || "");
            setClassroomSupportPlan(response.classroomsupportplan || false);
            setSencoEal(response.eal || false); // Initialize sencoEal from report
            setSet(response.set || false);
            setPlaceOnContinuum(response.supportcontinuum || []);
            setSencoAdditionalNeeds(response.additionalneeds || []);
            setPriorityConcerns(response.priorityconcerns || []);
            setSetReceived(response.setreceived || []);
            setSencoSupportPlan(response.supportplan || []);
          } else {
            setSencoEal(student.esl || false); // Fallback to student's esl status
          }
        })
        .catch((error) => {
          console.error("Error fetching SENCO report:", error);
          setSencoEal(student.esl || false); // Fallback if fetch fails
        });

      // Fetch class details
      getStudentClassDetail(student.id)
        .then((classDetails) => {
          if (classDetails) {
            setCallClassName(classDetails.className || "");
          }
        })
        .catch((error) =>
          console.error("Error fetching class details:", error)
        );
    }
  }, [student.id, student.esl]); // Add student.esl dependency

  const handleSenToggle = async (studentId, currentSenState) => {
    const updatedSenState = !currentSenState; // Flip the current state

    try {
      // Update the SEN state for the student
      await updateStudent(studentId, { sen: updatedSenState });

      // Update the local state to reflect the changes
      setStudentSenState((prevState) => ({
        ...prevState,
        [studentId]: updatedSenState, // Store the new state for the specific student
      }));
    } catch (error) {
      console.error("Error updating SEN state:", error);
    }
  };

  const handleEalToggle = async (studentId, currentEalValue) => {
    const newEalValue = !currentEalValue;
    setSencoEal(newEalValue); // Update local state immediately for responsiveness
    setEalModalButtonClicked(true); // Keep track of interaction if needed

    const reportData = {
      studentid: studentId,
      teacherid: teacherid,
      eal: newEalValue,
    };

    const studentUpdateData = {
      esl: newEalValue, // Update esl field in student record
    };

    try {
      // Update SENCO Report
      await upsertSencoReport(reportData);
      console.log("Upsert SENCO Report Success for EAL:", newEalValue);

      // Update Student Record
      await updateStudent(studentId, studentUpdateData);
      console.log("Update Student Success for ESL:", newEalValue);
    } catch (error) {
      console.error("Error updating EAL/ESL state:", error);
      setSencoEal(currentEalValue); // Optionally revert state if update fails
    }
  };

  const getButtonStyle = (buttonClicked, dataExists) => {
    return buttonClicked || dataExists ? { backgroundColor: "#ffffcc" } : {};
  };

  const getCircularButtonStyle = (
    buttonClicked,
    dataExists,
    borderColor = "black"
  ) => {
    const size = "40px";
    return {
      borderRadius: "50%",
      width: size,
      height: size,
      minWidth: size,
      minHeight: size,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      margin: "auto",
      border: `2px solid ${borderColor}`,
      backgroundColor: "white",
    };
  };

  return (
    <>
      {isWatchlistChecked && (
        <tr
          key={student.id}
          className="table-row student-results-table-row"
          data-student-id={student.id}
        >
          <td>
            <input
              type="checkbox"
              checked={
                studentSenState[student.id] !== undefined
                  ? studentSenState[student.id]
                  : student.sen
              }
              onChange={() => handleCheckboxClick(student)}
            />
          </td>
          <td className="centre-student-items align-left">{student.name}</td>

          {dummyHeaderArray.map((header, index) => (
            <td key={index} className="centre-student-items">
              {header === "Classroom Support Plan" ? (
                <img
                  src={
                    classroomSupportPlanModalClicked ||
                    classroomSupportPlan === true
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowClassroomSupportPlanModal(
                      student.name,
                      student.id
                    );
                    setClassroomSupportPlanClicked(true);
                  }}
                />
              ) : header === "Class" ? (
                <p>{callClassName}</p>
              ) : header === "SET" ? (
                <div className="custom-select-wrapper">
                  <select
                    className="custom-select"
                    value={setName}
                    style={{ width: "100px" }}
                    onChange={(e) => {
                      setCurrentStudentId(student.id);
                      setSetName(e.target.value);
                    }}
                  >
                    <option value="">Select SET</option>
                    {filteredTeachers.map((teacher) => (
                      <option key={teacher.id} value={teacher.name}>
                        {teacher.name}
                      </option>
                    ))}
                  </select>
                  <img
                    className="sort-icon"
                    src={
                      process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"
                    }
                    alt="Sort"
                  />
                </div>
              ) : header === "Details Of SET Received" ? (
                <img
                  src={
                    detailsOfSetReceivedButtonClicked || setReceived.length > 0
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowDetailsOfSetReceivedModal(
                      student.name,
                      student.id
                    );
                    setDetailsOfSetReceivedButtonClicked(true);
                  }}
                />
              ) : header === "Priority Concerns" ? (
                <img
                  src={
                    priorityConcernsButtonClicked || priorityConcerns.length > 0
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowPriorityConcernsModal(student.name, student.id);
                    setPriorityConcernsButtonClicked(true);
                  }}
                />
              ) : header === "Support Plan" ? (
                <img
                  src={
                    sencoSupportPlanButtonClicked || sencoSupportPlan.length > 0
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowSencoSupportPlanModal(student.name, student.id);
                    setSencoSupportPlanButtonClicked(true);
                  }}
                />
              ) : header === "Additional Needs" ? (
                <img
                  src={
                    additionalNeedsButtonClicked ||
                    sencoAdditionalNeeds.length > 0
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowSencoAdditionalNeedsModal(
                      student.name,
                      student.id
                    );
                    setAdditionalNeedsButtonClicked(true);
                  }}
                />
              ) : header === "EAL" ? (
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={sencoEal} // Use sencoEal state which reflects both report and student data
                    onChange={() => {
                      handleEalToggle(student.id, sencoEal); // Call the combined update function
                    }}
                    style={{
                      appearance: "none",
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      border: "2px solid #2c7693",
                      backgroundColor: "white",
                      cursor: "pointer",
                    }}
                  />
                  {sencoEal && (
                    <img
                      src="./assets/imgs/greenTick.svg"
                      alt="Checked"
                      style={{ width: "15px", position: "absolute" }}
                    />
                  )}
                </label>
              ) : header === "Place on Continuum" ? (
                <img
                  src={
                    placeOnContinuumButtonClicked || placeOnContinuum.length > 0
                      ? "./assets/imgs/file-pen-outline.svg"
                      : "./assets/imgs/file-outline.svg"
                  }
                  alt="View"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleShowPlaceOnContinuumModal(student.name, student.id);
                    setPlaceOnContinuumButtonClicked(true);
                  }}
                />
              ) : (
                <button className="white-button">
                  <i className="bi bi-pencil-square"></i>
                </button>
              )}
            </td>
          ))}
        </tr>
      )}

      <Modal
        show={showConfirmationModal}
        onHide={handleCancelRemove}
        style={{
          maxWidth: "400px",
          margin: "auto",
          top: "50%",
          transform: "translateY(-50%)", // Center the modal vertically
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to remove {selectedStudent?.name} from the
          watchlist?
        </Modal.Body>
        <Modal.Footer>
          <button className="white-action-button" onClick={handleCancelRemove}>
            Cancel
          </button>
          <button className="blue-action-button" onClick={handleConfirmRemove}>
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SENWatchlistTableRow;
